import types from 'actions/types';
import { capitalizedString, typeNotifyOptions } from 'utils/helpers';

const getInitialCollapsedSidebar = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.innerWidth <= 991;
};

const INITIAL_STATE = {
  collapsedSideBar: getInitialCollapsedSidebar(),
  confirmMessage: undefined,
  confirmCallback: undefined,
  labelAccept: undefined,
  labelRefuse: undefined,
  // #region notify
  typeNotify: undefined,
  openNotify: false,
  // #endregion
};

export default function globalReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.TRIGGER_SIDEBAR:
      return {
        ...state,
        collapsedSideBar: !state.collapsedSideBar,
      };
    case types.SHOW_CONFIRM_MODAL:
      return {
        ...state,
        confirmMessage: action.payload.message,
        confirmCallback: action.payload.confirmCallback,
        labelAccept: action.payload?.labelAccept,
        labelRefuse: action.payload?.labelRefuse,
      };
    case types.HIDE_CONFIRM_MODAL:
      return {
        ...state,
        confirmMessage: undefined,
        confirmCallback: undefined,
        labelAccept: undefined,
        labelRefuse: undefined,
      };
    case types.SHOW_NOTIFY:
      return {
        ...state,
        openNotify: true,
        typeNotify: typeNotifyOptions.find((e) => e?.value === action.payload),
      };
    case types.HIDE_NOTIFY: {
      return {
        ...state,
        openNotify: false,
        typeNotify: undefined,
      };
    }
    case types.COUNT_NOTIFY: {
      return {
        ...state,
        count: action.payload,
      };
    }
    default: {
      if (action.type.includes('GET_GLOBAL_OPTIONS')) {
        const fieldType = action.field;
        const fieldLoadingRequest = `get${capitalizedString(fieldType)}Loading`;
        const fieldLoadingMapRequest = `${fieldType}LoadingMap`;
        const fieldDataRequest = `${fieldType}Data`;
        const fieldParamsRequest = `${fieldType}Params`;
        const fieldCacheRequest = `${fieldType}Cache`;
        const currentLoadingMap = state[fieldLoadingMapRequest] || {};
        const nextLoadingMap = { ...currentLoadingMap };

        if (action.type.includes('REQUEST')) {
          nextLoadingMap[action.cacheKey] = true;
          state[fieldLoadingMapRequest] = nextLoadingMap;
          state[fieldLoadingRequest] = Object.values(nextLoadingMap).some(Boolean);
        } else if (action.type.includes('SUCCESS')) {
          nextLoadingMap[action.cacheKey] = false;
          state[fieldLoadingMapRequest] = nextLoadingMap;
          state[fieldLoadingRequest] = Object.values(nextLoadingMap).some(Boolean);
          state[fieldDataRequest] = action.payload;
          state[fieldParamsRequest] = action.params;
          state[fieldCacheRequest] = {
            ...(state[fieldCacheRequest] || {}),
            [action.cacheKey]: action.payload,
          };
        } else if (action.type.includes('FAILURE')) {
          nextLoadingMap[action.cacheKey] = false;
          state[fieldLoadingMapRequest] = nextLoadingMap;
          state[fieldLoadingRequest] = Object.values(nextLoadingMap).some(Boolean);
        }
      }
      return state;
    }
  }
}
